<template>
  <div>
    <div class="alert alert-success">
      <h3>Dziękujemy bardzo za wiadomość.</h3>
      <p>
        Zgłoszenie zostało zarejestrowane pod numerem
        <strong>{{data.formNumber}}</strong>.
        <br>Podczas kontaktu z nami prosimy powołać się na ten numer.
      </p>
      <p>Dodatkowo informujemy, że informację dotyczącą numeru i treści zgłoszenia przesłaliśmy na adres e-mail wskazany przez Pana/Panią w formularzu.</p>
    </div>
    <div>
      <a
        class="btn btn-primary pull-left"
        :href="data.pdfUrl"
        v-if="data.pdfUrl"
        target="_blank"
      >{{$t('btn_label_pdf')}} <span class="sr-only"> otwiera się w nowej karcie</span></a>
      <button type="button" class="btn btn-primary pull-right" @click="reload">{{$t('btn_label_close')}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "IcFormSent",
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    reload() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
h3 {
  margin: 0 0 10px 0;
  font-size: 22px;
}
.alert {
  font-size: 18px;
}
</style>
